import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import configureStore, { getPersist } from "./core/redux/index";
import { PersistGate } from "redux-persist/integration/react";
import MetaDecorator from "./components/MetaDecorator/MetaDecorator";
import { BrowserRouter as Router } from "react-router-dom";

// Disable console.log in production to improve performance and prevent data leaks
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep console.warn and console.error for critical issues
}

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={getPersist()}>
      <MetaDecorator />
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
